module.exports = __webpack_public_path__ + "img/b_bg.3377a467.jpg";